import { API_ROOT } from './apiConfig';
import Cookies from 'js-cookie';

class ApiTool {

  GET(url) {
    const csrftoken = Cookies.get('csrftoken');    
    return fetch(`${API_ROOT}${url}`,
    { credentials: 'include', 
      headers: {        
        'X-CSRFToken': csrftoken,       
      }
    })
    .then(response => {
      if (response.status === 403) {        
        console.log('not logged')
        //authClient(AUTH_ERROR)
        return response
      } else {
        return response
      }
    })    
  }

  POST(url, params) {
    const csrftoken = Cookies.get('csrftoken');
    return fetch(`${API_ROOT}${url}`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',          
          'X-CSRFToken': csrftoken,          
        },
        body: JSON.stringify(params)
    })
    .then(response => {
      if (response.status === 403) {
        console.log('not logged')
        return response
        //authClient(AUTH_ERROR)
      } else {
        return response
      }
    })    
  }
  
}

const API = new ApiTool()

export default API


// WEBPACK FOOTER //
// ./src/api/ApiTool.js